import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const ExpandedIcon = withSvgIcon(
    <path d="M204.9 409.4L54 258.5l150.4-150.4 31.8 31.8-118.6 118.6 119.1 119.1zM414.2 409.4L263.3 258.5l150.4-150.4 31.8 31.8-118.6 118.6L446 377.6z" />
);
